module.exports = __webpack_public_path__ + "static/img/ydcn@2x.9fa9733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/ydcn@2x.png
// module id = Hz1u
// module chunks = 3 4